import React from 'react';
import { array, number, object } from 'prop-types';
import { connect } from 'react-redux';
import { getPackageById } from '../../../reducers/packages';
import { BASIC_PACKAGE_ID } from '../../../utils/packagesUtils/constants';
import { getValidExtras } from '../../../utils/packagesUtils';
import PackageExtra from './PackageExtra';

const PackageExtras = ({
    packageId = BASIC_PACKAGE_ID,
    features = [],
    customExtras = [],
    extraFast
}) => {
    const extras = getValidExtras({ features, customExtras, extraFast });

    if (!extras.length) {return null;}

    return (
        <ul className="package-extras">
            {extras.map((extra, index) => (
                <PackageExtra key={index} {...extra} packageId={packageId}/>
            ))}
        </ul>
    );
};

PackageExtras.propTypes = {
    packageId: number,
    features: array,
    customExtras: array,
    extraFast: object
};

const mapStateToProps = ({ packages }, { packageId = BASIC_PACKAGE_ID }) => {
    const {
        features,
        customExtras,
        extraFast
    } = getPackageById(packages, packageId);

    return {
        features,
        customExtras,
        extraFast
    };
};

export { PackageExtras };
export default connect(mapStateToProps)(PackageExtras);
